import React from "react";
import { ShieldCheck } from "lucide-react";

export default function VerifiedBadge({ size = 12, className = "", label = "Verified" }) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-[#2B3A67] text-white text-[10px] uppercase tracking-[0.14em] font-medium ${className}`}
      data-testid="verified-badge"
      title="Verified owner"
    >
      <ShieldCheck size={size} /> {label}
    </span>
  );
}
